(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["block-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('block-slider')) {
    class BlockSlider extends HTMLElement {
      connectedCallback() {
        if (typeof Swiper !== 'undefined') {
          this.initSwiper();
        } else {
          const interval = setInterval(() => {
            if (typeof Swiper !== 'undefined') {
              this.initSwiper();
              clearInterval(interval);
            }
          }, 100);
        }
      }

      initSwiper() {
        const swiperEl = this.querySelector('.block-swiper');
        const wrapper = this.querySelector('.swiper-wrapper');
        if (!swiperEl || !wrapper) return;

        // Apply swiper-slide class to all direct children (each slide-item block)
        Array.from(wrapper.children).forEach(child => {
          child.classList.add('swiper-slide');
        });

        const autoplayEnabled = this.getAttribute('data-autoplay') === 'true';
        const autoplayDelay = parseInt(this.getAttribute('data-autoplay-delay')) || 3000;
        const loopEnabled = this.getAttribute('data-loop') === 'true';
        const effect = this.getAttribute('data-effect') || 'slide';

        const swiperOptions = {
          slidesPerView: 1,
          spaceBetween: 20,
          loop: loopEnabled,
          effect: effect,
          grabCursor: true,
          centeredSlides: true,
          watchOverflow: true,
          navigation: {
            nextEl: this.querySelector('.block-slider-nav-next'),
            prevEl: this.querySelector('.block-slider-nav-prev'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination-custom'),
            clickable: true,
            bulletClass: 'swiper-pagination-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active',
          },
          on: {
            init: function() {
              // Ensure only the active slide has aos-animate class
              const allAos = this.el.querySelectorAll('[data-aos]');
              allAos.forEach(el => {
                el.classList.remove('aos-animate');
              });
              const activeSlide = this.slides[this.activeIndex];
              if (activeSlide) {
                const aosElements = activeSlide.querySelectorAll('[data-aos]');
                aosElements.forEach(el => {
                  void el.offsetWidth;
                  el.classList.add('aos-animate');
                });
              }
            },
            slideChangeTransitionStart: function() {
              // Remove aos-animate class from all slides when starting transition
              const allAos = this.el.querySelectorAll('[data-aos]');
              allAos.forEach(el => {
                el.classList.remove('aos-animate');
              });
            },
            slideChangeTransitionEnd: function() {
              // Add aos-animate class only to the active slide's AOS elements
              const activeSlide = this.slides[this.activeIndex];
              if (activeSlide) {
                const aosElements = activeSlide.querySelectorAll('[data-aos]');
                aosElements.forEach(el => {
                  void el.offsetWidth;
                  el.classList.add('aos-animate');
                });
              }
            }
          }
        };

        if (autoplayEnabled) {
          swiperOptions.autoplay = {
            delay: autoplayDelay,
            disableOnInteraction: false,
          };
        }

        this.swiperInstance = new Swiper(swiperEl, swiperOptions);

        document.addEventListener('shopify:block:select', () => this.swiperInstance.update());
        document.addEventListener('shopify:block:deselect', () => this.swiperInstance.update());
      }

      disconnectedCallback() {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
        }
      }
    }

    customElements.define('block-slider', BlockSlider);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["programs-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('programs-slider')) {
    class ProgramsSlider extends HTMLElement {
      connectedCallback() {
        if (typeof Swiper !== 'undefined') {
          this.initSwiper();
        } else {
          const interval = setInterval(() => {
            if (typeof Swiper !== 'undefined') {
              this.initSwiper();
              clearInterval(interval);
            }
          }, 100);
        }
      }

      initSwiper() {
        const swiperEl = this.querySelector('.programs-swiper');
        const wrapper = this.querySelector('.swiper-wrapper');
        if (!swiperEl || !wrapper) return;

        // Apply swiper-slide class to all direct children
        Array.from(wrapper.children).forEach(child => {
          child.classList.add('swiper-slide');
        });

        const slidesDesktop = parseInt(this.getAttribute('data-slides-desktop')) || 3;
        const slidesMobile = parseFloat(this.getAttribute('data-slides-mobile')) || 1;

        const autoplayEnabled = this.getAttribute('data-autoplay') === 'true';
        const autoplayDelay = parseInt(this.getAttribute('data-autoplay-delay')) || 3000;
        const loopEnabled = this.getAttribute('data-loop') === 'true';

        const swiperOptions = {
          slidesPerView: slidesMobile,
          spaceBetween: 20,
          loop: loopEnabled,
          grabCursor: true,
          watchOverflow: true,
          navigation: {
            nextEl: this.querySelector('.programs-slider-nav-next'),
            prevEl: this.querySelector('.programs-slider-nav-prev'),
          },
          pagination: {
            el: this.querySelector('.programs-swiper-pagination'),
            clickable: true,
            bulletClass: 'swiper-pagination-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active',
          },
          breakpoints: {
            768: {
              slidesPerView: slidesDesktop > 1 ? 2 : 1,
              spaceBetween: 24,
            },
            1024: {
              slidesPerView: slidesDesktop,
              spaceBetween: 32,
            }
          }
        };

        if (autoplayEnabled) {
          swiperOptions.autoplay = {
            delay: autoplayDelay,
            disableOnInteraction: false,
          };
        }

        this.swiperInstance = new Swiper(swiperEl, swiperOptions);

        document.addEventListener('shopify:block:select', () => {
          if (this.swiperInstance) this.swiperInstance.update();
        });
        document.addEventListener('shopify:block:deselect', () => {
          if (this.swiperInstance) this.swiperInstance.update();
        });
      }

      disconnectedCallback() {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
        }
      }
    }

    customElements.define('programs-slider', ProgramsSlider);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["team-grid"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('team-slider')) {
    class TeamSlider extends HTMLElement {
      connectedCallback() {
        if (typeof Swiper !== 'undefined') {
          this.initSwiper();
        } else {
          const interval = setInterval(() => {
            if (typeof Swiper !== 'undefined') {
              this.initSwiper();
              clearInterval(interval);
            }
          }, 100);
        }
      }

      initSwiper() {
        const swiperEl = this.querySelector('.team-swiper');
        const wrapper = this.querySelector('.swiper-wrapper');
        if (!swiperEl || !wrapper) return;

        // Apply swiper-slide class to all direct children
        Array.from(wrapper.children).forEach(child => {
          child.classList.add('swiper-slide');
        });

        const columnsDesktop = parseInt(this.getAttribute('data-columns-desktop')) || 3;
        const columnsMobile = parseInt(this.getAttribute('data-columns-mobile')) || 1;
        const gap = parseInt(this.getAttribute('data-gap')) || 32;
        const gapMobile = parseInt(this.getAttribute('data-gap-mobile')) || 20;

        const autoplayEnabled = this.getAttribute('data-autoplay') === 'true';
        const autoplayDelay = parseInt(this.getAttribute('data-autoplay-delay')) || 3000;
        const loopEnabled = this.getAttribute('data-loop') === 'true';

        const swiperOptions = {
          slidesPerView: columnsMobile,
          spaceBetween: gapMobile,
          loop: loopEnabled,
          grabCursor: true,
          watchOverflow: true,
          breakpoints: {
            769: {
              slidesPerView: columnsDesktop,
              spaceBetween: gap,
            }
          },
          navigation: {
            nextEl: this.querySelector('.team-slider-nav-next'),
            prevEl: this.querySelector('.team-slider-nav-prev'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination-custom'),
            clickable: true,
            bulletClass: 'swiper-pagination-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active',
          }
        };

        if (autoplayEnabled) {
          swiperOptions.autoplay = {
            delay: autoplayDelay,
            disableOnInteraction: false,
          };
        }

        this.swiperInstance = new Swiper(swiperEl, swiperOptions);

        document.addEventListener('shopify:block:select', () => {
          if (this.swiperInstance) {
            this.swiperInstance.update();
          }
        });
        document.addEventListener('shopify:block:deselect', () => {
          if (this.swiperInstance) {
            this.swiperInstance.update();
          }
        });
      }

      disconnectedCallback() {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
        }
      }
    }

    customElements.define('team-slider', TeamSlider);
  }
  } catch(e) { console.error(e); }
})();

})();
